// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConsentCheckbox-module__wrapper___2k-BV","text":"ConsentCheckbox-module__text___wu2DQ"};